import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import OrderDetailsModal from "../../../Components/Caisses/Orders/OrderDetailsModal";
import {
  Bons,
  DefaultClient,
  Panier,
  Reduction,
  addClient,
  changetotal,
  findDefaultClientsBySociete,
  resetOperationType,
  resetPanier,
  resetReduction,
  setInitialTotals,
  setNetPrice,
} from "../../../_App/Redux/Slices/Caisse/PanierSlice";
import { selectedTable } from "../../../_App/Redux/Slices/Caisse/CaisseSlice";
import {
  EchangeTransactionApi,
  ListOrders,
  PayerReservationApi,
  ajoutAvanceApi,
  order,
  resetCachedOrders,
  resetRetrievedOrder,
  resetSelectedOrder,
  saveOrderTransactionApi,
  selectOrder,
  selectedOrder,
  updateOrderApi,
  updateReservationApi,
} from "../../../_App/Redux/Slices/Orders/OrderSlice";
import { ToastSuccess } from "../../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../../Shared/Toasts/ToastWarning";
import {
  SelectedOrganisation,
  SelectedOrganisationId,
  logoutApi,
  selectJournalCaisse,
  selectUser,
  selectedSessionJournal,
  societe,
  societeId,
} from "../../../_App/Redux/Slices/Auth/authSlice";
import { listPaymentOperations } from "../../../_App/Redux/Slices/payments/PaymentSlice";
import {
  findTypeMouvementByOrganisationApi,
  ListMouvementsCaisse,
  listTypeMouvements,
  saveMouvementsCaisseApi,
} from "../../../_App/Redux/Slices/mouvementCaisse/MouvementCaisseSlice";
import { updateFondCourantApi } from "../../../_App/Redux/Slices/journalCaisse/journalCaisseSlice";
import { updateTableStatusApi } from "../../../_App/Redux/Slices/table/tableSlice";
import {
  UnpaidTicket,
  findTicketsByOrderApi,
  findTicketsByOrganisationApi,
  ordersTickets,
  saveTicketApi,
  updateUserLocally,
} from "../../../_App/Redux/Slices/tickets/TicketSlice";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { updateArticleStockApi } from "../../../_App/Redux/Slices/article/articleSlice";
import { DepotDefautOrganisation } from "../../../_App/Redux/Slices/depot/depotSlice";
import Select from "react-select";
import {
  Vendeurs,
  findVendeurs,
} from "../../../_App/Redux/Slices/users/vendeurSlice";
import { parametrageCaisse } from "../../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import {
  createHistoriqueFidelite,
  findClientByBarcode,
  findClientById,
  ListClient,
  ListProgramFidelite,
  findClientBySocieteApi,
  updateClientApi,
} from "../../../_App/Redux/Slices/client/clientSlice";
import BonDeReductionTicket from "../../../Components/Caisses/TicketDeCaisse/BonDeReduction";
import BonReductionType from "../../../_App/Types/Entites/ReductionType";
import {
  ListBonsReduction,
  saveBonReductionApi,
  updateBon,
} from "../../../_App/Redux/Slices/reduction/reductionSlice";
import { ProgramFideliteType } from "../../../_App/Types/Entites/RemiseType";
import iconv from "iconv-lite"; // npm i iconv-lite

import ClientType, {
  HistoriqueFideliteType,
} from "../../../_App/Types/Entites/ClientType";
import { OrderType } from "../../../_App/Types/Entites/Orders/OrderType";
import Reservationpopup from "./Reservationpopup";
import PointsFidleliteMethod from "../../../Components/Caisses/Payment keyboard/PointsFidleliteMethod";
import CashPaymentMethod from "../../../Components/Caisses/Payment/CashPaymentMethod";
import ChequePaymentMethod from "../../../Components/Caisses/Payment/ChequePaymentMethod";
import GiftCardPaymentMethod from "../../../Components/Caisses/Payment/GiftCardPaymentMethod";
import {
  ChequeType,
  TraiteType,
} from "../../../_App/Types/Entites/PaymentType";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import BonReductionMethod from "../../../Components/Caisses/Payment/BonReductionMethod";
import VirementPaymentMethod from "../../../Components/Caisses/Payment/VirementPaymentMethod";
import {
  findSoucheCommande,
  ImpressionTicket,
} from "../../../_App/Helpers/helpers";
import VerifAdmin from "../../../Components/VerifUserCode/VerifAdmin";
import e from "express";
import TicketAvance from "../../../Components/Caisses/TicketDeCaisse/TicketAvance";
import { ActiveMenu } from "../../../_App/Redux/Slices/AppParametrages/parametrageMenus/parametrageMenuSlice";
import { isMatch } from "lodash";
import {
  findSocieteLivraison,
  SocieteLivraison,
} from "../../../_App/Redux/Slices/societe/societeSlice";
import CreditCardPaymentMethod from "../../../Components/Caisses/Payment/CreditCardPaymentMethod";
import HomeCaisse from "../../../Components/JournalCaisse/HomeCaisse";
import TicketDeCaisseModalMinime from "../../../Components/Caisses/TicketDeCaisse/TicketDeCaisseModalMinime";
import TicketDeCaisseModal from "../../../Components/Caisses/TicketDeCaisse/TicketDeCaisseModal";
import { Form, FormCheck } from "react-bootstrap";
import axios from "axios";
import { TiroirAction } from "../../../Shared/Hardware/TiroirAction";
import { PrintAction } from "../../../Shared/Hardware/PrintAction";
import { NotificationApi } from "../../../_App/Redux/Slices/notif/NotifSlice";
import { ToastInfo } from "../../../Shared/Toasts/ToastInfo";
import { useNavigate } from "react-router-dom";
import ClientPage from "../../../Pages/Client/ClientPage";
import TraitePaymentMethod from "../../../Components/Caisses/Payment/TraitePaymentMethod";
import CarteSedexoPaymentMethod from "../../../Components/Caisses/Payment/CarteSedexoPaymentMethod";
import {
  BOTTOM_MENU_HEIGHT,
  SMALL_PAYMENT_WIDTH,
  isSmallScreen,
} from "../../../_App/Helpers/screen";

export const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: "#151516",
    color: "white",
    borderRadius: "4px",
    border: "none",
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#e0f0ef" : "white",
    color: "black",
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: " white ", // Change this to your desired color
  }),
  input: (provided: any, state: any) => ({
    ...provided,
    color: "#888ea8", // Change this to your desired color
  }),

  // Style for the placeholder text
  placeholder: (provided: any, state: any) => ({
    ...provided,
    color: "white", // Change this to your desired color
  }),
  clearIndicator: (provided: any) => ({
    ...provided,
    color: "white",
    padding: "0 5px",
    transform: "scale(1.5)",
  }),
};

interface PaymentRightBarProps {
  visible: boolean;
  setVisible: any;
  ArticlesToPay: any;
  miniOrder: any;
}
interface PaidProduct {
  itemIndex: number;
  paid_quantity: number;
}

const PaymentDrawer: React.FC<PaymentRightBarProps> = ({
  visible,
  setVisible,
  miniOrder,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [status, setStatus] = useState("Ready");
  const [isLoading, setIsLoading] = useState(false);

  const openDrawer = async () => {
    await TiroirAction();
  };
  const cart = useSelector(Panier);
  const retrievedOrder = useAppSelector(order);
  const currentOrder = useAppSelector(selectedOrder);
  const openedOrder = retrievedOrder ? retrievedOrder : currentOrder;
  const unpaidTicket = useAppSelector(UnpaidTicket);

  const parametrage = useAppSelector(parametrageCaisse);
  const [timbre, setTimbre] = useState<number>(
    Number(parametrage.timbreTicket) || 0,
  );
  const [timbre_facture, setTimbre_Facture] = useState<number>(
    Number(parametrage.timbreFacture) || 0,
  );

  const [factureInclus, setFactureInclus] = useState<boolean>(false);
  const handleFactureSwitch = useCallback(() => {
    setFactureInclus((prev) => {
      const newValue = !prev;
      // Dispatch after state update is complete
      setTimeout(() => {
        dispatch(
          setInitialTotals({
            timbre: null, // keep existing
            timbre_facture: newValue ? timbre_facture : 0,
          }),
        );
        dispatch(setNetPrice());
      }, 0);
      return newValue;
    });
  }, [timbre_facture]);
  useEffect(() => {
    const init = async () => {
      if (parametrage && timbre && timbre_facture) {
        await dispatch(
          setInitialTotals({
            timbre: cart.timbre === 0 ? timbre : null,
            timbre_facture: !factureInclus
              ? 0
              : factureInclus && cart.timbre_facture === 0
              ? timbre_facture
              : null,
          }),
        );
        await dispatch(setNetPrice());
      }
    };
    init();
  }, [factureInclus, parametrage, timbre, timbre_facture]); // Proper dependencies

  const total = !cart?.avance
    ? openedOrder
      ? openedOrder.totalNet
      : cart.selectedOrders?.length !== 0
      ? cart.selectedOrders?.reduce((sum, order) => sum + order.totalNet, 0) -
        cart.refundedOrders.reduce(
          (sum, item) => sum + (item.societe_livraison?.frais_livraison ?? 0),
          0,
        )
      : cart.totalNet
    : cart.totalNet - cart.avance;
  const reduction = useAppSelector(Reduction);
  const bons = useAppSelector(Bons);
  let tempReduction = reduction;
  const selectedtable = useAppSelector(selectedTable);
  const orders = useAppSelector(ListOrders);
  const mouvementsCaisse = useAppSelector(ListMouvementsCaisse);
  const journal = useAppSelector(selectJournalCaisse);
  const defaultClient = useAppSelector(DefaultClient);
  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const Organisation = useAppSelector(SelectedOrganisation);
  const [showModalTicket, setShowModalTicket] = useState(false);
  const [showModalTicketAvance, setShowModalTicketAvance] = useState(false);
  const [Reservation, setReservation] = useState(false);
  const user = useAppSelector(selectUser);
  const bonsReduction = useAppSelector(ListBonsReduction);
  const societe_id = useAppSelector(societeId);
  const Societe = useAppSelector(societe);
  const listTypeMouvement = useAppSelector(listTypeMouvements);
  const [renduTotal, setrenduTotal] = useState(0);
  const societe_livraison = useAppSelector(SocieteLivraison);
  const [showModalAdmin, setshowModalAdmin] = useState(false);
  const [Admin, setAdmin] = useState(undefined);
  const [AdminVerif, setAdminVerif] = useState(false);
  const [client, setclient] = useState<ClientType>();
  const [actionreservation, setactionreservation] = useState("reservation");
  //usestate
  //paiements
  const [enteredAmount, setEnteredAmount] = useState<number | 0>(0);
  const [noteVirement, setNoteVirement] = useState("");
  const [file, setFile] = useState();
  const [selectedSocieteLivraison, setSelectedSocieteLivraison] =
    useState<any>(null);
  const [societeLivraisonOptions, setSocieteLivraisonOptions] = useState<any[]>(
    [],
  );

  useEffect(() => {
    if (societe_livraison && Array.isArray(societe_livraison)) {
      const options = societe_livraison.map((societe) => ({
        value: societe._id,
        label: societe.libelle,
        data: societe,
      }));
      setSocieteLivraisonOptions(options);

      // Sélectionner la première société par défaut si disponible
      if (options.length > 0 && !selectedSocieteLivraison) {
        const option = {
          value: cart.selectedOrders[0]?.societe_livraison?._id,
          label: cart.selectedOrders[0]?.societe_livraison?.libelle,
          data: cart.selectedOrders[0]?.societe_livraison
            ? cart.selectedOrders[0].societe_livraison
            : null,
        };
        setSelectedSocieteLivraison(option);
      }
    }
  }, [societe_livraison]);
  // cheques
  const [cheques, setCheques] = useState<ChequeType[]>([
    {
      tel: "",
      num_cheque: "",
      echeance: new Date(),
      amount: 0,
      client_id: cart.client_id?.toString(),
      paid: false,
      payment_id: "",
      organisation_id: currentOrganisation,
    },
  ]);
  const scrollRef = useRef<any>(null);

  const [traites, setTraites] = useState<TraiteType[]>([
    {
      tel: "",
      num_traite: "",
      echeance: new Date(),
      amount: 0,
      client_id: cart.client_id?.toString(),
      paid: false,
      payment_id: "",
      organisation_id: currentOrganisation,
    },
  ]);

  const [echeance, setEcheance] = useState<Date | null>();
  const [tel, setTel] = useState<string | null>();
  const [numCheque, setNumCheque] = useState<string | null>();
  const [enteredAmountCheque, setEnteredAmountCheque] = useState<number | 0>(0);

  const [enteredAmountTraite, setEnteredAmountTraite] = useState<number | 0>(0);

  const [enteredAmountCash, setEnteredAmountCash] = useState<number | 0>(0);
  useEffect(() => {
    if (parametrage && parametrage.payment_default_cash_amount === true) {
      console.log(parametrage.payment_default_cash_amount);
      setEnteredAmountCash(total);
    }
  }, [parametrage, total]);
  const [BonReductionAmount, setBonReductionAmount] = useState(0); // Initialize with 0 or default value
  const [numVirement, setNumeVirement] = useState("");
  const [montantVirement, setMontantVirement] = useState<number | 0>(0);
  const [taxes, setTaxes] = useState<number | 0>(0);

  const [enteredAmountGiftCard, setEnteredAmountGiftCard] = useState<
    number | 0
  >(0);
  const [enteredAmountCreditCard, setEnteredAmountCreditCard] = useState<
    number | 0
  >(0);

  const [enteredAmountCarteSedexo, setEnteredAmountCarteSedexo] = useState<
    number | 0
  >(0);
  const [fideliteAmount, setFideliteAmount] = useState<number | 0>(0);
  const [spentPoints, setSpentPoints] = useState<number | 0>(0);

  const [activePayment, setActivePayment] = useState("cash");

  const [idbon, setIdBon] = useState();

  const [showModalTicketBon, setShowModalTicketBon] = useState(false);
  const [ticketId, setTicketId] = useState<string | null>(null);
  const session = useAppSelector(selectedSessionJournal);
  const currentDepot = useAppSelector(DepotDefautOrganisation);
  const btnClass = " big-btn wide";
  const dureeAvance = parametrage?.duree_avance;
  const demande_avance = parametrage?.demandeAvance;
  const isCaisseClosed =
    !journal || journal.cloture || !session || session.cloture;
  const listClient = useAppSelector(ListClient);
  const { t } = useTranslation();
  const listpayment = useAppSelector(listPaymentOperations);
  const openedOrderId = openedOrder?._id;
  const [totalpayee, settotalpayee] = useState(0);
  const [currentClient, setCurrentClient] = useState<ClientType>();

  const [showReservationpopup, setshowReservationpopup] = useState(false);
  const [ShowModalActionCaisse, setShowModalActionCaisse] = useState(false);

  const vendeurRef = useRef<any>(null); // Référence pour contrôler le Select
  const onCloseCaisse = () => {
    setShowModalActionCaisse(false);
  };
  const [ListGiftcard, setListGiftcard] = useState<any>([
    { scan: "", provider: "", typecard: "", numcard: "", year: "", amount: 0 },
  ]);
  useEffect(() => {
    const totalChequeAmount = cheques.reduce(
      (sum, cheque) => sum + (Number(cheque.amount) || 0),
      0,
    );

    setEnteredAmountCheque(Number(totalChequeAmount));
    let totalEntredAmounts =
      Number(totalChequeAmount) +
      Number(enteredAmountTraite) +
      Number(enteredAmountCash) +
      Number(enteredAmountCreditCard) +
      Number(enteredAmountCarteSedexo) +
      Number(enteredAmountGiftCard) +
      Number(fideliteAmount) +
      Number(reduction);

    setEnteredAmount(Number(totalEntredAmounts));
  }, [cheques]);

  useEffect(() => {
    const totalTraiteAmount = traites.reduce(
      (sum, t) => sum + (Number(t.amount) || 0),
      0,
    );

    setEnteredAmountTraite(Number(totalTraiteAmount));
    let totalEntredAmounts =
      Number(totalTraiteAmount) +
      Number(enteredAmountCheque) +
      Number(enteredAmountCash) +
      Number(enteredAmountCreditCard) +
      Number(enteredAmountCarteSedexo) +
      Number(enteredAmountGiftCard) +
      Number(fideliteAmount) +
      Number(reduction);

    setEnteredAmount(Number(totalEntredAmounts));
  }, [traites]);

  useEffect(() => {
    const amount = Number(reduction);
    let totalEntredAmounts =
      Number(enteredAmountCheque) +
      Number(enteredAmountTraite) +
      Number(enteredAmountCash) +
      Number(enteredAmountCreditCard) +
      Number(enteredAmountCarteSedexo) +
      Number(enteredAmountGiftCard) +
      Number(fideliteAmount) +
      amount;
    setBonReductionAmount(amount);

    setEnteredAmount(Number(totalEntredAmounts));
  }, [reduction]);

  const addCheque = () => {
    setCheques([
      ...cheques,
      {
        tel: "",
        num_cheque: "",
        echeance: new Date(),
        amount: 0,
        client_id: cart.client_id.toString(),
        paid: false,
        payment_id: "",
        organisation_id: currentOrganisation,
      },
    ]);
  };

  const addTraite = () => {
    setTraites([
      ...traites,
      {
        tel: "",
        num_traite: "",
        echeance: new Date(),
        amount: 0,
        client_id: cart.client_id.toString(),
        paid: false,
        payment_id: "",
        organisation_id: currentOrganisation,
      },
    ]);
  };
  const updateCheque = (index: number, updatedCheque: ChequeType) => {
    const newCheques = [...cheques];
    newCheques[index] = updatedCheque;
    setCheques(newCheques);
  };
  const updateTraite = (index: number, updatedTraite: TraiteType) => {
    const newTraites = [...traites];
    newTraites[index] = updatedTraite;
    setTraites(newTraites);
  };
  const remainingAmount = Number(
    (
      total -
      (Number(enteredAmountCash) +
        Number(enteredAmountCheque) +
        Number(enteredAmountTraite) +
        Number(enteredAmountCreditCard) +
        Number(enteredAmountCarteSedexo) +
        Number(enteredAmountGiftCard) +
        Number(fideliteAmount) +
        reduction)
    ).toFixed(3),
  );

  // Methode de paiement
  useEffect(() => {
    if (total < 0 || (enteredAmount - reduction <= 0 && bons?.length === 1)) {
      setActivePayment("bon");
    } else if (cart.selectedOrders?.length) {
      setActivePayment("virement");
    } else if (total >= 0 && enteredAmount === enteredAmountCash) {
      setActivePayment("cash");
    }
  }, [cart, total, reduction, enteredAmount, bons]);

  useEffect(() => {
    if (scrollRef.current) {
      // scrollIntoView ou scrollTo peuvent être utilisés
      // "smooth" permet un défilement fluide au lieu d'un saut brusque
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [activePayment]);
  // client

  useEffect(() => {
    const getClient = async () => {
      if (cart.client_id) {
        const loyalClient = await dispatch(
          findClientById(cart.client_id.toString()),
        );
        if (loyalClient && loyalClient.payload)
          setCurrentClient(loyalClient.payload);
      }
    };
    getClient();
  }, [cart.client_id]);
  useEffect(() => {
    const getClient = async () => {
      const result = await dispatch(findClientById(cart.client_id.toString()));

      if (result.payload) {
        setclient(result.payload);
      }
    };

    if (cart.client_id) {
      getClient();
    }
  }, [cart.client_id, dispatch]);

  useEffect(() => {
    if (cart && cart.order_id) {
      let totalpaid;
      //alert("avance")
      if (cart && cart.avance) {
        totalpaid = cart.avance;
      } else {
        totalpaid = Number(
          listpayment.reduce((acc, val) => acc + val.amount, 0),
        );

        dispatch(changetotal({ total: cart.totalNet - totalpaid }));
      }
      settotalpayee(totalpaid);
    }
  }, [cart.order_id]);

  // entring amounts
  const handleEnteredAmount = (amount: number | 0) => {
    setEnteredAmountCash(amount);
    setEnteredAmount(
      Number(amount) +
        Number(enteredAmountCheque) +
        Number(enteredAmountTraite) +
        Number(enteredAmountCreditCard) +
        Number(enteredAmountCarteSedexo) +
        Number(enteredAmountGiftCard) +
        Number(fideliteAmount) +
        Number(reduction),
    );
  };

  const handleEnteredAmountGiftCard = (amount: number | 0) => {
    setEnteredAmountGiftCard(amount);
    const totalEntredAmounts =
      Number(enteredAmountCash) +
      Number(enteredAmountCheque) +
      Number(enteredAmountTraite) +
      Number(enteredAmountCreditCard) +
      Number(enteredAmountCarteSedexo) +
      Number(amount) +
      Number(fideliteAmount) +
      Number(reduction);

    setEnteredAmount(totalEntredAmounts);
  };
  const handleEnteredAmountCreditCard = (amount: number | 0) => {
    setEnteredAmountCreditCard(amount);
    const totalEntredAmounts =
      Number(enteredAmountCash) +
      Number(enteredAmountCheque) +
      Number(enteredAmountTraite) +
      Number(enteredAmountGiftCard) +
      Number(enteredAmountCarteSedexo) +
      Number(amount) +
      Number(fideliteAmount) +
      Number(reduction);
    setEnteredAmount(Number(totalEntredAmounts));
  };

  const handleEnteredAmountCarteSedexo = (amount: number | 0) => {
    setEnteredAmountCarteSedexo(amount);
    const totalEntredAmounts =
      Number(enteredAmountCash) +
      Number(enteredAmountCheque) +
      Number(enteredAmountTraite) +
      Number(enteredAmountCreditCard) +
      Number(enteredAmountGiftCard) +
      Number(amount) +
      Number(fideliteAmount) +
      Number(reduction);
    setEnteredAmount(Number(totalEntredAmounts));
  };
  const handleEnteredAmountFidelite = (amount: number | 0) => {
    console.log(client);
    setFideliteAmount(amount);

    // Recalculate how many points correspond to the chosen TND amount
    // using the client's ratio: points / equivalentMoney
    if (
      currentClient &&
      currentClient.equivalentMoney &&
      currentClient.equivalentMoney > 0
    ) {
      const pointsPerTND = currentClient.points / currentClient.equivalentMoney;
      const newSpentPoints = Math.round(Number(amount) * pointsPerTND);
      setSpentPoints(newSpentPoints);
    }

    // Only use the new amount, NOT the old fideliteAmount state
    const totalEntredAmounts =
      Number(enteredAmountCash) +
      Number(enteredAmountCheque) +
      Number(enteredAmountTraite) +
      Number(enteredAmountCreditCard) +
      Number(enteredAmountCarteSedexo) +
      Number(enteredAmountGiftCard) +
      Number(amount) + // ✅ Only use the new amount
      Number(reduction);
    setEnteredAmount(Number(totalEntredAmounts));
  };
  // end entering amounts

  function generateMouvementNumber(): string {
    let uniqueId: string;
    const existingOrderNumbers = mouvementsCaisse.map(
      (item) => item.operation_code,
    );
    do {
      uniqueId = "#" + (Math.floor(Math.random() * 90000) + 10000).toString();
    } while (
      existingOrderNumbers.some((operationCode) => operationCode === uniqueId)
    );

    return uniqueId;
  }
  const tickets = useAppSelector(ordersTickets);

  const saveMouvementCaisse = async (
    montant: number,
    paymentMethod: string,
    order: any,
    sens: any,
  ) => {
    const type_mouvement_id = listTypeMouvement.find(
      (item) => item.libelle === "Vente",
    )?._id;
    const type_mouvement_idExport = listTypeMouvement.find(
      (item) => item.libelle === "export",
    )?._id;
    let data = {
      operation_code: generateMouvementNumber(),
      caisse_code: "someCode",
      order_id: order,
      montant: Number(montant),
      date: new Date(),
      user_id: user?._id,
      journal_id: journal?._id,
      session_id: session?._id,
      payment_method: paymentMethod,

      organisation_id: currentOrganisation,
      commentaire: sens && sens === "d" ? "Remboursement" : null,
      type_mouvement_id:
        sens && sens === "d" ? type_mouvement_idExport : type_mouvement_id,
    };

    return data;
  };

  // payments methods

  const virement = async (order: any) => {
    const data = {
      operation_code: "4554",
      order_id: order._id,
      ticket_id: null,
      payment_method: "Virement",
      date: new Date(),
      amount: Number(order.totalNet.toFixed(3)),
      rendu: 0,
      code_caisse: "someCode",
      organisation_id: currentOrganisation ?? "defaultOrganizationId",
      transaction_Number: numVirement,
      virement: {
        numero: numVirement,
        amount: montantVirement,
        date: new Date(),
        payment_id: "",
        organisation_id: currentOrganisation,
        note: noteVirement,
        taxes: taxes,
        frais: selectedSocieteLivraison?.data?.virement,
        file: file,
      },
    };
    const respMvt = await saveMouvementCaisse(
      Number(order.totalNet.toFixed(3)),
      "Virement",
      order._id,
      null,
    );
    return { payement: data, Mouv: respMvt };
  };
  const fidelitePayment = async (order: any) => {
    const data = {
      operation_code: "4554",
      order_id: order._id,
      ticket_id: null,
      payment_method: "Points fidelité",
      points: spentPoints,
      date: new Date(),
      amount: Number(fideliteAmount)
        ? Number(fideliteAmount)
        : total?.toFixed(3),
      rendu: 0,
      code_caisse: "someCode",
      organisation_id: currentOrganisation ?? "defaultOrganizationId",
      transaction_Number: "",
    };

    const respMvt = await saveMouvementCaisse(
      Number(fideliteAmount)
        ? Number(fideliteAmount?.toFixed(3))
        : total?.toFixed(3),
      "Points fidelité",
      order._id,
      null,
    );
    return { payement: data, Mouv: respMvt };
  };
  const bonPayment = async (order: any, bon: BonReductionType) => {
    const amount = total >= bon.amount ? bon.amount : total;
    const data = {
      operation_code: "4554",
      order_id: order._id,
      ticket_id: null,
      payment_method: "bon",
      date: new Date(),
      amount: amount,
      rendu: 0,
      code_caisse: "someCode",
      organisation_id: currentOrganisation,
      transaction_Number: bon?._id,
      cheques: bon,
    };
    const respMvt = await saveMouvementCaisse(
      Number(bon.amount),
      "bon",
      order._id,
      null,
    );
    return { payement: data, Mouv: respMvt };
  };

  const cashPayment = async (order: any) => {
    const data = {
      operation_code: "4554",
      order_id: order._id,
      ticket_id: null,
      payment_method: "Espéces",
      date: new Date(),
      amount: Number(enteredAmountCash)
        ? Number(enteredAmountCash)
        : Number(total?.toFixed(3)),
      rendu: Number(enteredAmountCash)
        ? remainingAmount < 0
          ? remainingAmount * -1
          : 0
        : 0,

      code_caisse: "someCode",
      organisation_id: currentOrganisation ?? "defaultOrganizationId",
      transaction_Number: "",
    };
    const respMvt = await saveMouvementCaisse(
      Number(enteredAmountCash)
        ? Number(enteredAmountCash - data.rendu)
        : Number((total - data.rendu)?.toFixed(3)),
      "Cash",
      order._id,
      null,
    );
    return { payement: data, Mouv: respMvt };
  };
  const chequePayment = async (order: any, cheque: any) => {
    const data = {
      operation_code: "4554",
      order_id: order._id,
      ticket_id: null,
      payment_method: "Chéque",
      date: new Date(),
      amount: Number(cheque.amount),
      rendu: 0,
      code_caisse: "someCode",
      organisation_id: currentOrganisation,
      transaction_Number: cheque?.num_cheque,
      cheques: cheque,
    };
    const respMvt = await saveMouvementCaisse(
      Number(cheque.amount),
      "Chéque",
      order._id,
      null,
    );
    return { payement: data, Mouv: respMvt };
  };
  const traitePayment = async (order: any, traite: TraiteType) => {
    const data = {
      operation_code: "4554",
      order_id: order._id,
      ticket_id: null,
      payment_method: "Traite",
      date: new Date(),
      amount: Number(traite.amount),
      rendu: 0,
      code_caisse: "someCode",
      organisation_id: currentOrganisation,
      transaction_Number: traite?.num_traite,
      cheques: traite,
    };
    const respMvt = await saveMouvementCaisse(
      Number(traite.amount),
      "Traite",
      order._id,
      null,
    );
    return { payement: data, Mouv: respMvt };
  };
  const giftCardPayment = async (order: any, element: any) => {
    const today = new Date();
    const twoWeeksLater = new Date(today);
    if (parametrage.duree_bon) {
      twoWeeksLater.setDate(today.getDate() + Number(parametrage.duree_bon));
    } else {
      twoWeeksLater.setDate(today.getDate() + 15);
    }
    let dataBon: BonReductionType = {
      date: today,
      amount: Number(remainingAmount * -1),
      dateEcheance: twoWeeksLater,
      depot_id: currentDepot._id,
      code: generateCode(),
      type: "Contre bon",
      consumed: 0,
      sous_bon: false,
      valide: true,
    };
    const data = {
      operation_code: "4554",
      order_id: order._id,
      ticket_id: null,
      payment_method: "Tickets cadeaux",
      date: new Date(),
      rendu: 0,
      amount: Number(element.amount),
      code_caisse: "someCode",
      organisation_id: currentOrganisation ?? "defaultOrganizationId",
      transaction_Number: "",
      bon: remainingAmount < 0 ? dataBon : null,
      GiftCard: element,
    };

    const respMvt = await saveMouvementCaisse(
      Number(element.amount),
      "Tickets cadeaux",
      order._id,
      null,
    );
    return { payement: data, Mouv: respMvt };
  };
  const creditCardPayment = async (order: any) => {
    const data = {
      operation_code: "4554",
      order_id: order._id,
      ticket_id: null,
      payment_method: "Carte bancaire",
      date: new Date(),
      amount: Number(enteredAmountCreditCard),
      rendu: 0,
      code_caisse: "someCode",
      organisation_id: currentOrganisation ?? "defaultOrganizationId",
      transaction_Number: "",
    };

    const respMvt = await saveMouvementCaisse(
      Number(enteredAmountCreditCard),
      "Carte bancaire",
      order._id,
      null,
    );
    return { payement: data, Mouv: respMvt };
  };
  // end payments methods

  const carteSedoxoPayment = async (order: any) => {
    const data = {
      operation_code: "4554",
      order_id: order._id,
      ticket_id: null,
      payment_method: "Carte sedexo",
      date: new Date(),
      amount: Number(enteredAmountCarteSedexo),
      rendu: 0,
      code_caisse: "someCode",
      organisation_id: currentOrganisation ?? "defaultOrganizationId",
      transaction_Number: "",
    };

    const respMvt = await saveMouvementCaisse(
      Number(enteredAmountCarteSedexo),
      "Carte sedexo",
      order._id,
      null,
    );
    return { payement: data, Mouv: respMvt };
  };

  //payments

  const totalPayment = async (order: any) => {
    let response;
    let responseTicket;
    let tempOrder = _.cloneDeep(order);
    let previousStatus = tempOrder.status;
    if (user?.role_id?.libelle === "onlineSale") {
      if (
        !enteredAmountCash &&
        !enteredAmountCheque &&
        !enteredAmountTraite &&
        !enteredAmountCreditCard &&
        !enteredAmountCarteSedexo &&
        !enteredAmountGiftCard &&
        !numVirement &&
        !reduction
      ) {
        if (!numVirement) toast.warning("Numéro de virement est requis");
        else
          toast.warning(
            "Veuillez saisir au moins un montant dans un des champs.",
          );
      } else {
        response = await dispatch(
          updateOrderApi({
            orderId: order._id,
            status: "Payée",
            paidProducts: [],
            vendeur: null,
          }),
        );
        if (response.payload.success) {
          const respfonction = await fonctionpayment(order);

          const formData = new FormData();

          formData.append("order", JSON.stringify(order));
          formData.append(
            "Mvt",
            JSON.stringify(respfonction.lmvt == null ? [] : respfonction.lmvt),
          );

          formData.append("payment", JSON.stringify(respfonction.payment)); // exclude file field for now

          // If you have multiple files in payment[i].file
          respfonction.payment.forEach((pay, index) => {
            if (pay?.virement?.file) {
              formData.append(`file`, pay.virement.file);
            }
          });

          await resetPanierfunction();
          dispatch(resetReduction());
          ToastSuccess(response.payload.message);
        } else {
          ToastWarning(response.payload.message);
        }
      }
    } else {
      response = await dispatch(
        updateOrderApi({
          orderId: order._id,
          status: "Payée",
          paidProducts: [],
          vendeur: null,
        }),
      );
      const respfonction = await fonctionpayment(response.payload.data);

      tempOrder.status = "Payée";

      const obj = {
        ticket: {
          main_order: tempOrder._id,
          ticket_order:
            previousStatus === "Partiellement payée" ? unpaidTicket : tempOrder,
          type:
            previousStatus === "Nouvelle" || previousStatus === "demande Valide"
              ? "Total"
              : "Partiel",
          process: total && total < 0 ? "Retour" : "Vente",
        },
        order: tempOrder,
        payment: respfonction.payment,
        Mvt: respfonction.lmvt,
      };
      responseTicket = await dispatch(saveTicketApi(obj));

      if (responseTicket.payload.success) {
        if (responseTicket.payload.data.bon) {
          setIdBon(responseTicket.payload.data.bon._id);
          const dataBon = { bon: responseTicket.payload.data };
          await callImpression(dataBon, "Bon");
          //  setShowModalTicketBon(true);
        }

        const newTicketId = responseTicket.payload.data.ticket._id;
        setTicketId(newTicketId);
        await resetPanierfunction();
        dispatch(resetReduction());
      } else {
        ToastWarning(response.payload.message);
      }
      ToastSuccess(response.payload.message);
    }

    // response = await dispatch(
    //   updateOrderApi({
    //     orderId: order._id,
    //     status: "Payée",
    //     paidProducts: [],
    //     vendeur: null,
    //   }),
    // );
    // if (response.payload.success) {
    //   if (user?.role_id?.libelle === "onlineSale") {
    //     const respfonction = await fonctionpayment(order);

    //     const formData = new FormData();

    //     formData.append("order", JSON.stringify(order));
    //     formData.append(
    //       "Mvt",
    //       JSON.stringify(respfonction.lmvt == null ? [] : respfonction.lmvt),
    //     );

    //     formData.append("payment", JSON.stringify(respfonction.payment)); // exclude file field for now

    //     // If you have multiple files in payment[i].file
    //     respfonction.payment.forEach((pay, index) => {
    //       if (pay?.virement?.file) {
    //         formData.append(`file`, pay.virement.file);
    //       }
    //     });

    //     await resetPanierfunction();
    //     dispatch(resetReduction());
    //     ToastSuccess(response.payload.message);
    //   } else {
    //     const respfonction = await fonctionpayment(response.payload.data);

    //     tempOrder.status = "Payée";

    //     const obj = {
    //       ticket: {
    //         main_order: tempOrder._id,
    //         ticket_order:
    //           previousStatus === "Partiellement payée"
    //             ? unpaidTicket
    //             : tempOrder,
    //         type:
    //           previousStatus === "Nouvelle" ||
    //           previousStatus === "demande Valide"
    //             ? "Total"
    //             : "Partiel",
    //         process: total && total < 0 ? "Retour" : "Vente",
    //       },
    //       order: tempOrder,
    //       payment: respfonction.payment,
    //       Mvt: respfonction.lmvt,
    //     };
    //     responseTicket = await dispatch(saveTicketApi(obj));

    //     if (responseTicket.payload.success) {
    //       if (responseTicket.payload.data.bon) {
    //         setIdBon(responseTicket.payload.data.bon._id);
    //         const dataBon = { bon: responseTicket.payload.data };
    //         await callImpression(dataBon, "Bon");
    //         //  setShowModalTicketBon(true);
    //       }

    //       const newTicketId = responseTicket.payload.data.ticket._id;
    //       setTicketId(newTicketId);
    //       await resetPanierfunction();
    //       dispatch(resetReduction());
    //     } else {
    //       ToastWarning(response.payload.message);
    //     }
    //     ToastSuccess(response.payload.message);
    //   }
    // } else {
    //   ToastWarning(response.payload.message);
    // }
  };
  const fonctionpayment = async (order: any) => {
    let listP: any[] = [];
    let listM: any[] = [];
    if (
      !enteredAmountCash &&
      !enteredAmountCheque &&
      !enteredAmountTraite &&
      !enteredAmountCreditCard &&
      !enteredAmountCarteSedexo &&
      !enteredAmountGiftCard &&
      !numVirement &&
      !reduction
    ) {
      toast.warning("Veuillez saisir au moins un montant dans un des champs.");
    } else {
      if (Number(enteredAmountCheque) > 0) {
        cheques.forEach(async (element) => {
          const resp = await chequePayment(order, element);
          listP = [...listP, resp.payement];
          listM = [...listM, resp.Mouv];
        });
      }
      if (Number(enteredAmountTraite) > 0) {
        traites.forEach(async (element) => {
          const resp = await traitePayment(order, element);
          listP = [...listP, resp.payement];
          listM = [...listM, resp.Mouv];
        });
      }
      if (Number(enteredAmountGiftCard) > 0) {
        ListGiftcard.forEach(async (element: any) => {
          const resp = await giftCardPayment(order, element);
          listP = [...listP, resp.payement];
          listM = [...listM, resp.Mouv];
        });
      }
      if (Number(enteredAmountCash) > 0) {
        const resp = await cashPayment(order);
        listP = [...listP, resp.payement];
        listM = [...listM, resp.Mouv];
      }
      if (Number(enteredAmountCreditCard) > 0) {
        const resp = await creditCardPayment(order);
        listP = [...listP, resp.payement];
        listM = [...listM, resp.Mouv];
      }
      if (Number(enteredAmountCarteSedexo) > 0) {
        const resp = await carteSedoxoPayment(order);
        listP = [...listP, resp.payement];
        listM = [...listM, resp.Mouv];
      }
      if (fideliteAmount > 0) {
        const resp = await fidelitePayment(order);
        listP = [...listP, resp.payement];
        listM = [...listM, resp.Mouv];
      }
      if (tempReduction && cart?.Bons?.length > 0) {
        cart.Bons.forEach(async (element: BonReductionType) => {
          const resp = await bonPayment(order, element);
          listP = [...listP, resp.payement];
          listM = [...listM, resp.Mouv];
        });
        if (enteredAmount - reduction <= 0 && bons?.length === 1) {
          bonRendu(Math.abs(total - reduction), true, bons[0]);
        }
      }
      if (numVirement) {
        const resp = await virement(order);
        listP = [...listP, resp?.payement];
        listM = [...listM, resp?.Mouv];
      }
    }
    if (journal) {
      const resp = await dispatch(
        updateFondCourantApi({
          id: journal._id,
          fond_courant: Number(
            Number(journal.fond_courant) + Number(order.total),
          )?.toFixed(3),
        }),
      );
      if (resp.payload.horsLigne) {
        console.log("object");
      }
    }
    return { payment: listP, lmvt: listM };
  };

  const handlePayOrder = async (order: any) => {
    if (cart.selectedOrders?.length !== 0) {
      await totalPayment(order);
    }
    dispatch(resetSelectedOrder());
  };
  const clientFidelite = async (order: any) => {
    console.log(spentPoints);
    if (!client) return;
    let newPoints = client.points;
    let newEquivalentMoney = client.equivalentMoney;

    // 1. SUBTRACT only the points/money that were actually used for payment
    if (spentPoints > 0 || fideliteAmount > 0) {
      newPoints = Math.max(0, newPoints - spentPoints);
      newEquivalentMoney = Math.max(0, newEquivalentMoney - fideliteAmount);
    }

    // 2. ADD new points earned from this purchase
    if (cart.programmesFidelite?.length) {
      for (const item of cart.programmesFidelite) {
        const earnedPoints = item?.points * (item.multiplicateur_fidelite || 1);
        const earnedMoney =
          Number(item.equivalentMoney) * (item.multiplicateur_fidelite || 1);

        newPoints += earnedPoints;
        newEquivalentMoney += earnedMoney;

        // Create history record for earned points
        const data: HistoriqueFideliteType = {
          client_id: cart.client_id.toString(),
          date: new Date(),
          order_id: order,
          organisation_id: currentOrganisation ? currentOrganisation : "",
          points: earnedPoints,
          program_fidelite: item._id,
        };

        try {
          await dispatch(createHistoriqueFidelite(data));
        } catch (error) {
          console.error("Error creating fidelity history", error);
        }
      }
    }

    // 3. Update client with new totals
    try {
      await dispatch(
        updateClientApi({
          _id: cart.client_id.toString(),
          points: newPoints,
          equivalentMoney: newEquivalentMoney,
        }),
      );
    } catch (error) {
      console.error("Error updating client", error);
    }
  };

  const reptureAlerts = async (orderItems: any) => {
    for (const value of orderItems) {
      const res = await dispatch(
        updateArticleStockApi({
          id: value.article._id,
          depotId: currentDepot._id,
          soldQuantity: value.quantity,
          type: value?.type,
          organisation: currentOrganisation,
          defaut_id: value?.defaut_id,
        }),
      );
      if (
        res.payload.success &&
        parametrage &&
        res.payload?.data?.stock < value?.article?.minimalStock
      ) {
        if (res.payload?.data?.stock === 0) {
          toast.error(
            `L'article ${value.article?.titre?.fr}  est en rupture de stock !`,
          );
        } else {
          toast.warning(
            `L'article ${value.article?.titre?.fr}  est  en rupture de stock ! Stock actuel : ${res.payload.data.stock}`,
          );
        }
      }
    }
  };
  const bonRendu = async (
    amount: number,
    sous_bon: boolean,
    bon: BonReductionType | null,
  ) => {
    console.log("bon rendu");
    const today = new Date();
    const twoWeeksLater = new Date(today);
    if (parametrage.duree_bon) {
      twoWeeksLater.setDate(today.getDate() + Number(parametrage.duree_bon));
    } else {
      twoWeeksLater.setDate(today.getDate() + 15);
    }
    let data: BonReductionType = {
      date: today,
      amount: amount,
      dateEcheance: sous_bon && bon ? bon.dateEcheance : twoWeeksLater,
      depot_id: currentDepot._id,
      code: generateCode(),
      type: "Contre bon",
      consumed: 0,
      sous_bon: true,
      valide: true,
      bon_parent: bons[0]?._id,
    };
    const res1 = await dispatch(
      updateBon({
        id: bons[0]?._id,
        data: {
          consumed: total,
        },
      }),
    );
    const res = await dispatch(saveBonReductionApi(data));
    if (res.payload.success) {
      setIdBon(res.payload.data._id);
      const dataBon = { bon: res.payload.data };
      await callImpression(dataBon, "Bon");
      // setShowModalTicketBon(true);
    }
  };
  const RefundCash = async () => {
    saveMouvementCaisse(Math.abs(total), "Cash", null, "d");
  };

  function generateCode(): string {
    let uniqueId: string;
    const existingCodes = Object.values(bonsReduction).map(
      (item) => item[0]?.code,
    );
    do {
      uniqueId = (Math.floor(Math.random() * 900000) + 100000).toString();
    } while (existingCodes.some((operationCode) => operationCode === uniqueId));

    return uniqueId;
  }
  const handleRefund = async (type: string) => {
    try {
      let order: any = { ...cart };
      delete order.calculatedQuantity;
      delete order.itemsRefunded;

      delete order.orderConfirmed;
      delete order.Bons;
      delete order.InstantRemise;
      delete order.avance;
      delete order.depots_id;
      delete order.gratuites;
      delete order.operationType;
      delete order.order_id;
      delete order.programmesFidelite;
      delete order.reduction;
      delete order.refundedArticle;
      // delete order.refundedOrder;
      delete order.reservation;
      delete order.refundedOrders;
      delete order.selectedOrders;
      delete order.typeRemise;

      if (currentOrganisation) {
        order.organisation_id = currentOrganisation;
      }
      order.items = [...cart.items, ...cart.refundedItems];
      order.date = new Date();
      order.table_id = selectedtable ? selectedtable._id : null;
      order.total = cart.total?.toFixed(3);
      order.totalNet = cart.totalNet?.toFixed(3);
      order.status = type;
      order.client_id = cart.client_id;
      order.clientRemise = cart.clientRemise;
      order.societe_id = societe_id;
      order.depots_id = currentDepot._id;
      order.user_id = user?._id;
      if (journal) order.journal_id = journal._id;
      order.vendeur =
        selectedOption && selectedOption.value
          ? selectedOption.value
          : user?._id;

      if (cart.refundedOrder) {
        const totalPayments =
          Number(enteredAmountCash) +
          Number(enteredAmountCheque) +
          Number(enteredAmountTraite) +
          Number(enteredAmountCreditCard) +
          Number(enteredAmountCarteSedexo) +
          Number(enteredAmountGiftCard) +
          Number(fideliteAmount) +
          Number(cart.avance || 0) +
          reduction;

        // ✅ Check if at least one payment input is filled
        if (
          total > 0 &&
          !enteredAmountCash &&
          !enteredAmountCheque &&
          !enteredAmountTraite &&
          !enteredAmountCreditCard &&
          !enteredAmountCarteSedexo &&
          !enteredAmountGiftCard &&
          !numVirement &&
          !reduction
        ) {
          toast.warning(
            "Veuillez saisir au moins un montant dans un des champs.",
          );
          return;
        }
        // ✅ Check if total payments cover the total
        if (Number(totalPayments.toFixed(2)) < Number(total.toFixed(2))) {
          toast.warning(
            `Reste a payer : ${(Number(total) - Number(totalPayments)).toFixed(
              3,
            )} TND !`,
          );
          return;
        }

        let responsefonct;
        if (total && total > 0) {
          responsefonct = await fonctionpayment(order);
        } else if (total < 0) {
          setActivePayment("bon");
        }
        order.order_id = cart?.refundedOrder._id;

        let avoirOrder = { ...order };
        avoirOrder.status =
          cart.operationType === "Retour" ? "Avoir" : "Echange";
        avoirOrder.date = new Date();
        avoirOrder.type = "caisse";

        let RefundMouvement;
        if (cart.operationType === "Retour") {
          console.log("order", order);
          RefundMouvement = await saveMouvementCaisse(
            Number(order?.totalNet),
            "Bon",
            undefined,
            "d",
          );
        } else {
          RefundMouvement = await saveMouvementCaisse(
            total.toFixed(3),
            activePayment,
            undefined,
            "c",
          );
        }
        //call transaction
        const objTranscationEch = {
          order: order,
          order_id: cart.refundedOrder._id,
          depot: currentDepot,
          organisation: currentOrganisation,
          orderAvoir: avoirOrder,
          type,
          MouvementsCaisselist: [RefundMouvement],
          PaymentOperationsList: responsefonct ? responsefonct["payment"] : [],
          etatId: cart.refundedOrder?.etatRetour?._id,
        };

        const respTransaction = await dispatch(
          EchangeTransactionApi(objTranscationEch),
        );
        if (respTransaction.payload.success) {
          if (respTransaction.payload.data.bon) {
            setIdBon(respTransaction.payload.data.bon._id);

            // print Bon directly
            const dataBon = { bon: respTransaction.payload.data.bon };
            await callImpression(dataBon, "Bon");
            //setShowModalTicketBon(true);
          }

          const newTicketId = respTransaction.payload.data.ticket._id;
          setTicketId(newTicketId);

          // print Ticket directly
          const dataTicket = {
            ticket: respTransaction.payload.data.ticket,
            paymentList: objTranscationEch.PaymentOperationsList,
          };
          await callImpression(dataTicket, "Ticket Caisse");

          if (total > 0) {
            await openDrawer();
          }
          setShowModalTicket(true);

          if (total < 0) {
            bonRendu(Number(Math.abs(cart.totalNet)), false, null);
          } else {
            await RefundCash();
          }

          await resetPanierfunction();
          dispatch(resetReduction());
        } else {
          ToastWarning(respTransaction.payload.message);
        }
      }
    } catch (error) {
      console.error("Error during refund process:", error);
    }
  };

  const paymentRightBarRef = useRef<HTMLDivElement>(null);

  //call impression
  const callImpression = async (dataTicket: any, type: any) => {
    const findVendeur = vendeurs.find((v) => v._id === selectedOption?.value);
    const lines: any = ImpressionTicket(
      type,
      {
        ...dataTicket,
        societe: Societe,
        organisation: Organisation,
        user,
        vendeur: findVendeur || user,
      },
      parametrage,
    );

    const finalBuffer = (() => {
      const allBytes: number[] = [];
      lines.forEach((line: any) => {
        if (line instanceof Uint8Array) {
          allBytes.push(...line);
        } else {
          const buf = iconv.encode(line + "\n", "ISO-8859-1");
          allBytes.push(...buf);
        }
      });
      return new Uint8Array(allBytes);
    })();
    console.log("lines", lines);
    await PrintAction(finalBuffer, parametrage.OpenTiroire, true);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        paymentRightBarRef.current &&
        !paymentRightBarRef.current.contains(event.target as Node)
      ) {
        if (setVisible) setVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setVisible]);
  useEffect(() => {
    if (openedOrder && openedOrder._id)
      dispatch(findTicketsByOrderApi(openedOrder._id));
    if (currentOrganisation) dispatch(findVendeurs(currentOrganisation));
  }, [dispatch, openedOrder]);
  useEffect(() => {
    if (currentOrganisation)
      dispatch(findTypeMouvementByOrganisationApi(currentOrganisation));
  }, [currentOrganisation]);
  useEffect(() => {
    if (societe_id) {
      dispatch(findClientBySocieteApi(societe_id));
      dispatch(findDefaultClientsBySociete(societe_id));
      dispatch(findSocieteLivraison(societe_id));
    }
  }, [societe_id]);
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const vendeurs = useAppSelector(Vendeurs);

  const options = vendeurs.map((item) => ({
    value: item._id,
    label: item.nom,
    code: item.code, // Ajout du code ici
    data: item,
  }));

  const customFilter = (option: any, inputValue: any) => {
    if (!inputValue) return true;

    return (
      option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
      option.data.code.toLowerCase().includes(inputValue.toLowerCase()) // Recherche aussi par code
    );
  };
  const lastKeyPressTime = useRef<number>(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleInputChange = (inputValue: string) => {
    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;

    // Si le temps entre deux entrées est court, c'est probablement un scan
    const isScannerInput = timeDiff < 50;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(
      () => {
        const matchingOption = options.find(
          (option) =>
            option?.data?.code?.toLowerCase() === inputValue.toLowerCase() ||
            option?.label?.toLowerCase() === inputValue.toLowerCase(),
        );
        if (matchingOption) {
          setSelectedOption(matchingOption);

          // Fermer la liste en déclenchant manuellement la sélection
          if (vendeurRef.current) {
            vendeurRef.current.setValue(matchingOption, "select-option");
          }
        }
      },
      isScannerInput ? 100 : 1500,
    );
  };
  const handleSelectChange = (selectedOption: any) => {
    setSelectedOption(selectedOption);
  };
  const handleFideliteAmount = async () => {
    const result = await dispatch(findClientById(cart.client_id.toString()));

    if (result && result.payload) {
      const equivalentMoney = result.payload.equivalentMoney || 0;
      const totalPoints = result.payload.points || 0;
      // Pre-fill with the full available amount, but never more than the
      // total to pay; the cashier can then reduce it on demand
      const prefillAmount = Math.min(
        equivalentMoney,
        Number(total) || equivalentMoney,
      );
      const pointsPerTND =
        equivalentMoney > 0 ? totalPoints / equivalentMoney : 0;
      setFideliteAmount(prefillAmount);
      setSpentPoints(Math.round(prefillAmount * pointsPerTND));
      // Update the global entered amount so the total reflects the points immediately
      const totalEntredAmounts =
        Number(enteredAmountCash) +
        Number(enteredAmountCheque) +
        Number(enteredAmountTraite) +
        Number(enteredAmountCreditCard) +
        Number(enteredAmountCarteSedexo) +
        Number(enteredAmountGiftCard) +
        Number(prefillAmount) +
        Number(reduction);
      setEnteredAmount(totalEntredAmounts);
    }
  };

  useEffect(() => {
    if (reduction && reduction >= total) {
      setEnteredAmountCash(0);
    } else if (parametrage && parametrage.payment_default_cash_amount) {
      setEnteredAmountCash(total);
    } else {
      setEnteredAmountCash(0);
    }
  }, [reduction, cart, openedOrder]);

  useEffect(() => {
    setEnteredAmountCheque(0);
    setEnteredAmountTraite(0);
    setEnteredAmountGiftCard(0);
    setEnteredAmountCreditCard(0);
    setFideliteAmount(0);
    setBonReductionAmount(0);

    setEcheance(null);
    setTel("");
    setNumCheque("");
    setCheques([
      {
        tel: "",
        num_cheque: "",
        echeance: new Date(),
        amount: 0,
        client_id: cart?.client_id?.toString(),
        paid: false,
        payment_id: "",
        organisation_id: currentOrganisation,
      },
    ]);
    setListGiftcard([]);
  }, [openedOrder, cart]);

  const handleConfirmOrder = async (data: any, status: string) => {
    const totalPayments =
      Number(enteredAmountCash) +
      Number(enteredAmountTraite) +
      Number(enteredAmountCarteSedexo) +
      Number(enteredAmountCheque) +
      Number(enteredAmountCreditCard) +
      Number(enteredAmountGiftCard) +
      Number(fideliteAmount) +
      Number(cart.avance || 0) +
      reduction;

    if (
      (selectedOption || !parametrage.vendeur_obligatoire) &&
      Number(totalPayments.toFixed(2)) >= Number(total.toFixed(2))
    ) {
      let order = { ...data };
      delete order.calculatedQuantity;
      delete order.orderConfirmed;
      let response: any;
      if (currentOrganisation) {
        order.organisation_id = currentOrganisation;
      }
      order.items = cart.items;
      order.date = new Date();
      order.table_id = selectedtable ? selectedtable._id : null;
      order.total = Number(cart.total).toFixed(3);
      order.totalNet = Number(cart.totalNet).toFixed(3);
      if (cart.order_id === null) order.status = status;
      order.client_id = cart.client_id;
      order.clientRemise = cart.clientRemise;
      order.societe_id = societe_id;
      order.depots_id = currentDepot._id;
      order.type = "caisse";

      if (journal) order.journal_id = journal?._id;
      order.vendeur =
        selectedOption && selectedOption.value
          ? selectedOption.value
          : user?._id;
      if (user) order.user_id = user?._id;
      try {
        const rspayment = await fonctionpayment(order);
        const lists = { payment: rspayment.payment, Mvt: rspayment.lmvt };
        const TransactioObj = {
          total,
          data: order,
          reservationData: null,
          lists,
        };
        const respTransaction = await dispatch(
          saveOrderTransactionApi(TransactioObj),
        );
        if (respTransaction.payload.success) {
          let ticketNew = respTransaction.payload.data.tickets.ticket;
          let bon = respTransaction?.payload?.data?.tickets?.bon;
          const obj = {
            ticket: {
              main_order:
                respTransaction.payload.data.tickets.ticket.main_order,
              ticket_order:
                respTransaction.payload.data.tickets.ticket.ticket_order,
              type: "Total",
              process: total && total < 0 ? "Retour" : "Vente",
            },
            order: data,
            payment: rspayment.payment,
            Mvt: rspayment.lmvt,
          };

          const newTicketId = ticketNew._id;
          if (bon) {
            setIdBon(bon._id);
            const dataBon = { bon: bon };
            await callImpression(dataBon, "Bon");
            // setShowModalTicketBon(true);
          }

          setTicketId(newTicketId);
          // call Impression Function
          const resumeFidelite = cart.programmesFidelite?.length
            ? cart.programmesFidelite.reduce(
                (acc, item) =>
                  acc + item?.points * (item.multiplicateur_fidelite || 1),
                0,
              )
            : 0;
          const dataTicket = {
            ticket: obj.ticket,
            paymentList: obj.payment,
            pointsfidelite: resumeFidelite,
            pointsClient: client?.points
              ? client.points + resumeFidelite
              : null,
          };
          console.log("dataTicket", dataTicket);
          console.log("dataTicket", dataTicket);
          await callImpression(dataTicket, "Ticket Caisse");
          await openDrawer();
          setShowModalTicket(true);
          clientFidelite(
            respTransaction.payload.data.tickets.ticket.main_order,
          );
          resetPanierfunction();
          await dispatch(resetReduction());

          await dispatch(addClient(defaultClient._id));
          ///  handlePayOrder(response.payload.data);
          setEnteredAmountCash(0);
          setEnteredAmountGiftCard(0);
          setEnteredAmountCreditCard(0);
        } else {
          ToastWarning(response.payload.message);
        }
      } catch (error) {
        // Handle error appropriately
        console.error(error);
      }
    } else {
      if (!selectedOption && parametrage?.vendeur_obligatoire)
        toast.warning("Veuillez selectionner un vendeur !");

      if (Number(total.toFixed(2)) - Number(totalPayments.toFixed(2)) > 0) {
        toast.warning(
          `Reste a payer : ${(Number(total) - Number(totalPayments)).toFixed(
            3,
          )} TND !`,
        );
      }
    }
  };

  // Clears every payment method amount so the "Avance" popup always starts
  // from a clean slate, regardless of what was left over in the payment tabs.
  const resetAllPaymentAmounts = () => {
    setEnteredAmount(0);
    setEnteredAmountCash(0);
    setCheques([
      {
        tel: "",
        num_cheque: "",
        echeance: new Date(),
        amount: 0,
        client_id: cart.client_id?.toString(),
        paid: false,
        payment_id: "",
        organisation_id: currentOrganisation,
      },
    ]);
    setTraites([
      {
        tel: "",
        num_traite: "",
        echeance: new Date(),
        amount: 0,
        client_id: cart.client_id?.toString(),
        paid: false,
        payment_id: "",
        organisation_id: currentOrganisation,
      },
    ]);
    setEnteredAmountCreditCard(0);
    setEnteredAmountCarteSedexo(0);
    setListGiftcard([
      { scan: "", provider: "", typecard: "", numcard: "", year: "", amount: 0 },
    ]);
    setEnteredAmountGiftCard(0);
    setFideliteAmount(0);
    setSpentPoints(0);
  };

  const handlereserverOrder = async () => {
    if (!isCaisseClosed) {
      if (cart.items?.length === 0) {
        ToastWarning(t("choisissez un article"));
      } else {
        resetAllPaymentAmounts();
        setshowReservationpopup(true);
      }
    } else {
      navigate("/HomeCaisse");
    }
  };
  const confirmreservation = async (data: any, inforeservation: any) => {
    let valide: any = true;
    let demande: any = false;

    if (!inforeservation.mobile) {
      ToastWarning("le numéro de telephone est obligatoire ");
      return;
    }
    const montantAv =
      Number(enteredAmountCash) +
      Number(enteredAmountCheque) +
      Number(enteredAmountTraite) +
      Number(enteredAmountCreditCard) +
      Number(enteredAmountCarteSedexo) +
      Number(enteredAmountGiftCard) +
      Number(fideliteAmount);
    if(montantAv <= 0){
      ToastWarning("ajouter un montant d'avance");
      return;
    }
    if (
      demande_avance &&
      inforeservation.duree > dureeAvance &&
      user?.role_id?.libelle !== "admin" &&
      !AdminVerif
    ) {
      const res = await demandeDureeAvance();
      if (res === "confirmed") {
        valide = true;
        demande = true;
      } else if (res === "codeAdmin") {
        setshowModalAdmin(true);
        valide = false;
        demande = false;
      } else {
        valide = false;
        demande = false;
      }
    }
    if (valide || AdminVerif) {
      setshowReservationpopup(false);
      let order = { ...data };
      delete order.calculatedQuantity;
      delete order.orderConfirmed;
      let response: any;
      if (currentOrganisation) {
        order.organisation_id = currentOrganisation;
      }
      const respfonction = await fonctionpayment(data);

      order.items = cart.items;
      order.date = new Date();
      order.table_id = selectedtable ? selectedtable._id : null;

      order.type = "caisse";
      order.societe_id = societe_id;

      order.status = demande ? "avance en cours de validation" : "reservation";
      order.client_id = cart.client_id;
      order.journal_id = journal?._id;
      order.depots_id = currentDepot._id ? currentDepot._id : null;
      order.vendeur =
        selectedOption && selectedOption.value
          ? selectedOption.value
          : user?._id;
      order.enteredAmountCash = Number(enteredAmountCash);
      order.enteredAmountCheque = Number(enteredAmountCheque);
      order.reservationdata = {
        avance: [
          {
            total: montantAv,
            cash: Number(enteredAmountCash),
            cheque: Number(enteredAmountCheque),
            date: new Date(),
            num: 1,

            payment: respfonction.payment,
            Mvt: respfonction.lmvt,
          },
        ],

        demande: demande,
        duree: inforeservation.duree,
        date_echeance: inforeservation.date_echeance,
        infoclient: {
          client: inforeservation.client,
          nom: inforeservation.nom,
          mobile: inforeservation.mobile,
        },
        avance_valide: !demande,
        achat_total: order.total,

        achat_totalNet: order.totalNet,
      };
      order.total = montantAv;
      order.totalNet = montantAv;
      order.user_id = user?._id;
      try {
        if (order) {
          const lists = {
            payment: respfonction.payment,
            Mvt: respfonction.lmvt,
          };

          const TransactioObj = {
            total,
            data: order,
            reservationData: order.reservationdata,
            lists,
          };
          const respTransaction = await dispatch(
            saveOrderTransactionApi(TransactioObj),
          );
          if (respTransaction.payload.success) {
            let ticketNew = respTransaction.payload.data.tickets.ticket;
            let bon = respTransaction?.payload?.data?.tickets?.bon;
            const obj = {
              ticket: {
                main_order:
                  respTransaction.payload.data.tickets.ticket.main_order,
                ticket_order:
                  respTransaction.payload.data.tickets.ticket.ticket_order,
                type: "Total",
                process: total && total < 0 ? "Retour" : "Vente",
              },
              order: data,
              payment: respfonction.payment,
              Mvt: respfonction.lmvt,
            };

            clientFidelite(
              respTransaction.payload.data.tickets.ticket.main_order,
            );
            resetPanierfunction();
            await dispatch(resetReduction());

            await dispatch(addClient(defaultClient._id));

            const newTicketId = ticketNew._id;
            if (bon) {
              setIdBon(bon._id);
              const dataBon = { bon: bon };
              await callImpression(dataBon, "Bon");
              // setShowModalTicketBon(true);
            }

            setTicketId(newTicketId);
            // call Impression Function
            const dataTicket = {
              ticket: respTransaction.payload.data.tickets.ticket,
              paymentList: obj.payment,
              totalavance:
                respTransaction.payload.data.reservation?.avance.reduce(
                  (accumulator: any, currentValue: any) =>
                    accumulator + currentValue.total,
                  0,
                ),
              Reservation: respTransaction.payload.data.reservation,
            };

            //  await callImpression(dataTicket, "Avance");
            await callImpression(dataTicket, "Avance");
            await callImpression(dataTicket, "Avance");

            await openDrawer();
            //  setShowModalTicket(true);
            ///  handlePayOrder(response.payload.data);
            setEnteredAmountCash(0);
            setEnteredAmountGiftCard(0);
            setEnteredAmountCreditCard(0);
          } else {
            ToastWarning(respTransaction.payload.message);
          }
        } else {
          ToastSuccess("demande envoyée");
        }

        resetPanierfunction();
        dispatch(addClient(defaultClient._id));
        //  dispatch(getOrderByIdApi(response.payload.data._id));

        setEnteredAmountCash(0);
        setEnteredAmount(0);

        setEnteredAmountGiftCard(0);
        setEnteredAmountCreditCard(0);
        await dispatch(resetReduction());

        setAdminVerif(false);
        ToastSuccess(response.payload.message);
        /* else {
          ToastWarning(response.payload.message);
        }
        dispatch(resetRetrievedOrder());
        setshowReservationpopup(false);
        setEnteredAmountCash(0);
        setEnteredAmountGiftCard(0);
        setEnteredAmountCreditCard(0);
        resetPanierfunction();*/
      } catch (error) {
        console.error(error);
      }
    }
  };

  const PayerReservation = async (datacart: any) => {
    if (!isCaisseClosed) {
      if (
        (selectedOption || !parametrage.vendeur_obligatoire) &&
        Number(remainingAmount.toFixed(2)) <= 0
      ) {
        setIsLoading(true);
        try {
          const paiementdata = {
            giftcard: Number(enteredAmountGiftCard),
            cheque: Number(enteredAmountCheque),
            cash: Number(enteredAmountCash),
            remainingAmount: Number(remainingAmount * -1),
          };
          let order = { ...datacart };
          delete order.calculatedQuantity;
          delete order.orderConfirmed;
          let response: any;
          if (currentOrganisation) {
            order.organisation_id = currentOrganisation;
          }
          order.items = cart.items;
          order.date = new Date();
          order.table_id = selectedtable ? selectedtable._id : null;
          order.totalNet = cart.totalNet;
          order.total = cart.total;
          order.client_id = cart.client_id;
          order.journal_id = journal?._id;
          order.depots_id = currentDepot._id ? currentDepot._id : null;
          order.vendeur =
            selectedOption && selectedOption.value
              ? selectedOption.value
              : user?._id;
          order.enteredAmountCash = Number(enteredAmountCash);
          order.enteredAmountCheque = Number(enteredAmountCheque);

          order.user_id = user?._id;
          const resp = await fonctionpayment(order);
          const data = {
            paiementdata: paiementdata,
            order: order,
            payment: resp?.payment,
            MVtCaisse: resp?.lmvt,
          };
          response = await dispatch(PayerReservationApi(data));
          if (response.payload.success) {
            if (total < 0) {
              bonRendu(Number(total.toFixed(3) * -1), false, null);
            }

            const newTicketId = response.payload.data.ticket._id; // Assuming _id is the ID property
            setTicketId(newTicketId);

            setTicketId(response.payload.data.ticket);

            const dataTicket = {
              ticket: response.payload.data.ticket,
              paymentList: paiementdata,
              totalavance: response.payload.data.reservation?.achat_totalNet,
              Reservation: response.payload.data.reservation,
            };
            setReservation(response.payload.data.reservation);
            // setShowModalTicketAvance(true);
            openDrawer();
            await callImpression(dataTicket, "Avance");
            setactionreservation("reservation");
            await callImpression(dataTicket, "Avance");
            resetPanierfunction();
            dispatch(resetRetrievedOrder());

            dispatch(addClient(defaultClient._id));
            setEnteredAmountCash(0);
            setEnteredAmountGiftCard(0);
            setEnteredAmountCreditCard(0);
          } else {
            ToastWarning(response.payload.message);
          }
        } finally {
          setIsLoading(false);
        }
      } else {
        toast.warning(`Reste a payer : ${remainingAmount.toFixed(3)} TND !`);
      }
    } else {
      navigate("/HomeCaisse");
    }
  };
  const AjouterAvance = async (inforeservation: any) => {
    const montant_avance =
      Number(enteredAmountCash || 0) +
      Number(enteredAmountCheque || 0) +
      Number(enteredAmountTraite || 0) +
      Number(enteredAmountCreditCard || 0) +
      Number(enteredAmountCarteSedexo || 0) +
      Number(enteredAmountGiftCard || 0) +
      Number(fideliteAmount || 0);
    if (montant_avance === 0) {
      // update seulement l'avance info
      const data = {
        _id: inforeservation._id,
        data: {
          active: true,

          date_echeance: inforeservation.date_echeance,
          duree: inforeservation.duree,
          items: cart?.reservation.items,
        },
      };

      const res = await dispatch(updateReservationApi(data));
      if (res.payload.success) {
        setshowReservationpopup(false);
        resetPanierfunction();
        ToastSuccess("Les données d'avance ont changé ");
      }
    } else {
      if (!isCaisseClosed) {
        const resfonction = await fonctionpayment(openedOrder);
        const data = {
          Reservation: {
            _id: inforeservation._id,
            date_echeance: inforeservation.date_echeance,
            duree: inforeservation.duree,
            items: cart?.reservation.items,
          },
          avance: {
            total: montant_avance,
            cash: Number(enteredAmountCash),
            cheque: Number(enteredAmountCheque),

            num:
              cart.reservation.avance[cart?.reservation?.avance?.length - 1]
                .num + 1,
          },
          ticket: {
            main_order: openedOrder._id,
            ticket_order: openedOrder,
            type: "Avance",
            process: "Vente",
            num:
              cart.reservation.avance[cart?.reservation?.avance?.length - 1]
                .num + 1,
          },
          payment: resfonction.payment,
          Mvt: resfonction.lmvt,
          items: cart.items,
          total: cart.total,
          totalNet: cart.totalNet,
        };
        const res = await dispatch(ajoutAvanceApi(data));
        if (res.payload.success) {
          const idticket = res.payload.data.ticket;
          setTicketId(idticket);
          const dataTicket = {
            ticket: data.ticket,
            paymentList: data.payment,
            totalavance: res.payload.data.Reservation?.avance.reduce(
              (accumulator: any, currentValue: any) =>
                accumulator + currentValue.total,
              0,
            ),
            Reservation: res.payload.data.Reservation,
          };
          openDrawer();
          await callImpression(dataTicket, "Avance");
          setReservation(res.payload.data.Reservation);
          await callImpression(dataTicket, "Avance");

          // setShowModalTicketAvance(true);
          setactionreservation("reservation");
          ///  handlePayOrder(response.payload.data);
          dispatch(resetRetrievedOrder());
          setshowReservationpopup(false);
          setEnteredAmountCash(0);
          setEnteredAmountGiftCard(0);
          setEnteredAmountCreditCard(0);
          resetPanierfunction();
        }
      } else {
        setshowReservationpopup(false);
        navigate("/HomeCaisse");
      }
    }
  };

  const orderConfirmationAlert = () => {
    if (!isCaisseClosed) {
      Swal.fire({
        title: "Voulez-vous confirmer ?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setIsLoading(true);
          try {
            if (openedOrder !== null) {
              if (
                cart.operationType === "Retour" ||
                cart.operationType === "Echange"
              ) {
                await handleRefund(cart.operationType);
              } else {
                const copie = { ...openedOrder };
                copie.items = cart.items;
                await handlePayOrder(copie);
              }
            } else if (cart.selectedOrders?.length !== 0) {
              await Promise.all(
                cart.selectedOrders.map((item) => handlePayOrder(item)),
              );
            } else {
              if (
                cart.operationType === "Retour" ||
                cart.operationType === "Echange"
              ) {
                await handleRefund(cart.operationType);
              } else {
                await handleConfirmOrder(cart, "Payée");
              }
            }
          } finally {
            setIsLoading(false);
          }
        }
      });
    } else {
      navigate("/HomeCaisse");
    }
  };

  const resetPanierfunction = async () => {
    await dispatch(resetSelectedOrder());
    await dispatch(resetCachedOrders());
    const timbre = await parametrage.timbreTicket;
    await dispatch(resetPanier(timbre || 0));
    await dispatch(setNetPrice());

    setSelectedOption(null);
    await dispatch(addClient(defaultClient._id));
    setEnteredAmount(0);
    setEnteredAmountCash(0);
    setCheques([
      {
        tel: "",
        num_cheque: "",
        echeance: new Date(),
        amount: 0,
        client_id: cart.client_id?.toString(),
        paid: false,
        payment_id: "",
        organisation_id: currentOrganisation,
      },
    ]);
    setEnteredAmountCheque(0);
    setEnteredAmountTraite(0);

    setEcheance(null);
    setTel("");
    setNumCheque("");
    setEnteredAmountGiftCard(0);
    setEnteredAmountCreditCard(0);
    setActivePayment("cash");
  };
  const demandeDureeAvance = async () => {
    const result = await Swal.fire({
      title:
        "Voulez-vous envoyer une demande d'augmentation de la durée d'avance?",
      icon: "warning",
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
      denyButtonText: "Entrer code  admin",
    });
    if (result.isConfirmed) {
      return "confirmed";
    } else if (result.isDenied) {
      return "codeAdmin";
    } else {
      return "annuler";
    }
  };
  /*******************************************Notifs *************************/
  /*useEffect(() => {
    findListNotification();
  }, []);
  const findListNotification = async () => {
    if (currentOrganisation) {
      const res = await dispatch(NotificationApi(currentOrganisation));
      console.log("res", res);
      if (res.payload?.success) {
        const { demandes, reservations } = res.payload.data;

        // ✅ Gestion des toasts
        if (Array.isArray(demandes)) {
          demandes.forEach((demande) => {
            const orgName = demande.organisation_demande?.nom || "inconnue";
            ToastInfo(`🏬 Nouvelle demande de transfert reçue de ${orgName}`);
          });
        }

        if (Array.isArray(reservations)) {
          reservations.forEach((transfer) => {
            const orgName = transfer.organisation_transfer?.nom || "inconnue";
            ToastInfo(
              `📦 Le magasin ${orgName} attend la confirmation du transfert`,
            );
          });
        }
      }
    }
  };*/
  const Menu = useAppSelector(ActiveMenu);
  return (
    <div
      className={
        setVisible
          ? visible === true
            ? "col-right-content-container payment-rightbar displayed"
            : "col-right-content-container payment-rightbar"
          : "fixed-payment-rightbar"
      }
      ref={paymentRightBarRef}
      style={{
        height:
          Menu?.menuPosition.position === "down"
            ? `calc(100vh - ${BOTTOM_MENU_HEIGHT})`
            : "100%",
        width: !setVisible && isSmallScreen ? SMALL_PAYMENT_WIDTH : undefined,

        right:
          Menu?.menuPosition.position === "right"
            ? "130px" // Try changing this to "0" or adjusting dynamically
            : 0,
        top: Menu?.menuPosition.position === "up" ? "130px" : 0,
        bottom: Menu?.menuPosition.position === "down" ? BOTTOM_MENU_HEIGHT : 0,
      }}
    >
      <div
        className="widget-message widget-message-p"
        style={{
          padding: "10px",
          marginTop: Menu && Menu.menuPosition.position === "up" ? "130px" : 0,
        }}
      >
        <div className="widget-title mb-10">
          <h5 onClick={() => console.log("payment method : ", activePayment)}>
            {total && total < 0 ? "Remboursement" : t("payment")}
          </h5>
          {setVisible ? (
            <button
              className="delete-button"
              onClick={(e) => {
                if (setVisible) setVisible(false);
              }}
              style={{ float: "right" }}
            >
              <i
                className="fas fa-times"
                style={{ width: "auto", display: "flex" }}
              ></i>
            </button>
          ) : (
            <Form.Group controlId="formConge">
              <Form.Label className="mr-2">{t("Facture")}</Form.Label>
              <div
                style={{
                  float: "right",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <FormCheck
                  type="switch"
                  id="conge-switch"
                  checked={factureInclus}
                  onChange={handleFactureSwitch}
                />
                {/* {factureInclus ? (
                      <i
                        className="fas fa-umbrella-beach"
                        style={{
                          color: "#c12cdd",
                          marginLeft: "20px",
                          fontSize: "20px",
                        }}
                      ></i>
                    ) : (
                      <i
                        className="fas fa-business-time"
                        style={{
                          color: "blue",
                          marginLeft: "20px",
                          fontSize: "20px",
                        }}
                      ></i>
                    )} */}
              </div>
            </Form.Group>
          )}
        </div>
      </div>
      <div style={{ margin: "7px 0" }}>
        <Select
          ref={vendeurRef} // Référence pour contrôler le Select
          className="basic color-black fs-17"
          options={options}
          isSearchable={true}
          onChange={handleSelectChange}
          value={selectedOption}
          styles={customStyles}
          placeholder={"Vendeur / vendeuse"}
          filterOption={customFilter}
          onInputChange={handleInputChange} // Déclenche la sélection automatique
          isClearable={true}
        />
      </div>

      {cart.order_id && cart.avance && (
        <div className="widget-todo" style={{ width: "100%" }}>
          <div className="todo-content">
            <div className="todo-title">
              <h6>
                <span>{t("Avance")}</span>
              </h6>
            </div>
            <div className="todo-text">
              <p>{totalpayee?.toFixed(3) || ""}</p>
            </div>
          </div>
        </div>
      )}
      {/* {total ? (
        <div className="widget-todo">
          <div className="todo-content">
            <div className="todo-title">
              <h6>
                <span className="align-self-center">{t("total_to_pay")}</span>
              </h6>
            </div>
            <div className="todo-text">
              <p>{total?.toFixed(3)}</p>
            </div>
          </div>
        </div>
      ) : null} */}

      <div
        className="activity-section activity-section-maxHeigh"
        ref={scrollRef}
        style={{
          overflowY: "auto",
          overflowX: "hidden",
          maxHeight:
            Menu && Menu.menuPosition.position === "left"
              ? "calc(100vh - 196px)"
              : Menu && Menu.menuPosition.position === "up"
              ? "calc(100vh - 306px)"
              : "calc(100vh - 320px)",
          display: "flex",
          flexDirection: "column",
          bottom: 0,
          position: "static",
          top: "200px",
        }}
      >
        <div>
          <div className="row m-2">
            {enteredAmountCash > 0 ? (
              <div className="widget-todo col-4">
                <div className="todo-content">
                  <div className="todo-title">
                    <h6>
                      <span className="align-self-center">{t("Espéces")}</span>
                    </h6>
                  </div>
                  <div className="todo-text">
                    <p>{Number(enteredAmountCash)?.toFixed(3)}</p>
                  </div>
                </div>
              </div>
            ) : null}
            {enteredAmountCheque > 0 ? (
              <div className="widget-todo col-4">
                <div className="todo-content">
                  <div className="todo-title">
                    <h6>
                      <span className="align-self-center">{t("Chéque")}</span>
                    </h6>
                  </div>
                  <div className="todo-text">
                    <p>{enteredAmountCheque?.toFixed(3)}</p>
                  </div>
                </div>
              </div>
            ) : null}
            {enteredAmountTraite > 0 ? (
              <div className="widget-todo col-4">
                <div className="todo-content">
                  <div className="todo-title">
                    <h6>
                      <span className="align-self-center">{t("Traite")}</span>
                    </h6>
                  </div>
                  <div className="todo-text">
                    <p>{enteredAmountTraite?.toFixed(3)}</p>
                  </div>
                </div>
              </div>
            ) : null}
            {enteredAmountGiftCard > 0 ? (
              <div className="widget-todo col-4">
                <div className="todo-content">
                  <div className="todo-title">
                    <h6>
                      <span className="align-self-center">
                        {t("T.cadeaux")}
                      </span>
                    </h6>
                  </div>
                  <div className="todo-text">
                    <p>{Number(enteredAmountGiftCard)?.toFixed(3)}</p>
                  </div>
                </div>
              </div>
            ) : null}
            {enteredAmountCreditCard > 0 ? (
              <div className="widget-todo col-4">
                <div className="todo-content">
                  <div className="todo-title">
                    <h6>
                      <span className="align-self-center">{t("Carte")}</span>
                    </h6>
                  </div>
                  <div className="todo-text">
                    <p>{enteredAmountCreditCard}</p>
                  </div>
                </div>
              </div>
            ) : null}
            {enteredAmountCarteSedexo > 0 ? (
              <div className="widget-todo col-4">
                <div className="todo-content">
                  <div className="todo-title">
                    <h6>
                      <span className="align-self-center">
                        {t("Carte sedexo")}
                      </span>
                    </h6>
                  </div>
                  <div className="todo-text">
                    <p>{enteredAmountCarteSedexo}</p>
                  </div>
                </div>
              </div>
            ) : null}
            {fideliteAmount > 0 ? (
              <div className="widget-todo col-4">
                <div className="todo-content">
                  <div className="todo-title">
                    <h6>
                      <span className="align-self-center">{t("Points")}</span>
                    </h6>
                  </div>
                  <div className="todo-text">
                    <p>{fideliteAmount}</p>
                  </div>
                </div>
              </div>
            ) : null}

            {reduction > 0 ? (
              <div className="widget-todo col-4">
                <div className="todo-content">
                  <div className="todo-title">
                    <h6>
                      <span className="align-self-center">{t("Bon")}</span>
                    </h6>
                  </div>
                  <div className="todo-text">
                    <p>{reduction?.toFixed(3)}</p>
                  </div>
                </div>
              </div>
            ) : null}
          </div>

          {remainingAmount !== 0 ? (
            <div className="widget-todo" style={{ width: "100%" }}>
              <div className="todo-content">
                <div className="todo-title">
                  <h6>
                    <span className="align-self-center">
                      {Number(enteredAmountCash) +
                        Number(enteredAmountCheque) +
                        Number(enteredAmountTraite) +
                        Number(enteredAmountCreditCard) +
                        Number(enteredAmountCarteSedexo) +
                        Number(enteredAmountGiftCard) +
                        Number(fideliteAmount) +
                        reduction <
                      total
                        ? t("Remaining to Pay")
                        : t("Rendu")}
                    </span>
                  </h6>
                </div>
                <div
                  className="todo-text"
                  onClick={() => console.log(enteredAmount)}
                >
                  <p>
                    {remainingAmount !== null
                      ? remainingAmount?.toFixed(3)
                      : ""}
                  </p>
                </div>
              </div>
            </div>
          ) : null}
          {user && user.role_id?.libelle === "onlineSale" ? (
            <div className="widget-todo" style={{ width: "100%" }}>
              <div className="todo-content">
                <div className="todo-title">
                  <h6>
                    <span className="align-self-center">
                      {t("Societe de livraison")}
                    </span>
                  </h6>
                </div>
                <div className="todo-text" style={{ width: "100%" }}>
                  {societeLivraisonOptions.length > 0 && (
                    <Select
                      className="basic color-black fs-17"
                      options={societeLivraisonOptions}
                      isSearchable={true}
                      onChange={(option) => setSelectedSocieteLivraison(option)}
                      value={selectedSocieteLivraison}
                      styles={customStyles}
                      placeholder={"Choisir une société de livraison"}
                      isClearable={true}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : null}
          <nav id="payment-block">
            <ul className="menu-payments" style={{ flexWrap: "wrap" }}>
              {user && user.role_id?.libelle === "onlineSale" ? (
                <li className="menu active">
                  <a
                    data-active="true"
                    className="menu-toggle"
                    onClick={() => {
                      setActivePayment("virement");
                    }}
                    style={{
                      borderColor:
                        activePayment && activePayment === "virement"
                          ? "#009688" // Change to the desired background color
                          : "",
                    }}
                  >
                    <div className="base-menu">
                      <div className="base-icons">
                        <i className="fas fa-exchange-alt"></i>{" "}
                      </div>
                      <span>Virement</span>
                    </div>
                  </a>
                </li>
              ) : null}

              {total >= 0 ? (
                <>
                  <li className={total >= 0 ? "menu active" : "menu"}>
                    <a
                      data-active={total >= 0 ? "true" : "false"}
                      className="menu-toggle"
                      onClick={() => {
                        setActivePayment("cash");
                      }}
                      style={{
                        borderColor:
                          activePayment && activePayment === "cash"
                            ? "#009688" // Change to the desired background color
                            : "",
                      }}
                    >
                      <div className="base-menu">
                        <div className="base-icons">
                          <i className="fas fa-money-bill-alt"></i>{" "}
                        </div>
                        <span>Espéces</span>
                      </div>
                    </a>
                  </li>

                  <li className={total < 0 ? "menu active" : "menu"}>
                    <a
                      data-active={total < 0 ? "true" : "false"}
                      className="menu-toggle"
                      onClick={() => {
                        setActivePayment("cheque");
                      }}
                      style={{
                        borderColor:
                          activePayment && activePayment === "cheque"
                            ? "#009688" // Change to the desired background color
                            : "",
                      }}
                    >
                      <div className="base-menu">
                        <div className="base-icons">
                          <i className="fas fa-money-check-alt"></i>
                        </div>
                        <span>Chéque</span>
                      </div>
                    </a>
                  </li>
                  <li className={total < 0 ? "menu active" : "menu"}>
                    <a
                      data-active={total < 0 ? "true" : "false"}
                      className="menu-toggle"
                      onClick={() => {
                        setActivePayment("traite");
                      }}
                      style={{
                        borderColor:
                          activePayment && activePayment === "traite"
                            ? "#009688" // Change to the desired background color
                            : "",
                      }}
                    >
                      <div className="base-menu">
                        <div className="base-icons">
                          <i className="fas fa-money-check-alt"></i>
                        </div>
                        <span>{t("Traite")}</span>
                      </div>
                    </a>
                  </li>
                  {user && user.role_id?.libelle !== "onlineSale" ? (
                    <>
                      <li className="menu">
                        <a
                          data-active="false"
                          className="menu-toggle"
                          onClick={() => {
                            setActivePayment("gift card");
                          }}
                          style={{
                            borderColor:
                              activePayment && activePayment === "gift card"
                                ? "#009688" // Change to the desired background color
                                : "",
                          }}
                        >
                          <div className="base-menu">
                            <div className="base-icons">
                              <i className="fas fa-gift"></i>
                            </div>
                            <span>{t("Tickets cadeaux")} </span>
                          </div>
                        </a>
                      </li>
                      <li className={total < 0 ? "menu active" : "menu"}>
                        <a
                          data-active={total < 0 ? "true" : "false"}
                          className="menu-toggle"
                          onClick={() => {
                            setActivePayment("carte sedexo");
                          }}
                          style={{
                            borderColor:
                              activePayment && activePayment === "carte sedexo"
                                ? "#009688" // Change to the desired background color
                                : "",
                          }}
                        >
                          <div className="base-menu">
                            <div className="base-icons">
                              <i className="fas fa-money-check-alt"></i>
                            </div>
                            <span>{t("carte sedexo")}</span>
                          </div>
                        </a>
                      </li>
                    </>
                  ) : null}
                  {user && user.role_id?.libelle !== "onlineSale" ? (
                    <li className="menu">
                      <a
                        data-active="false"
                        className="menu-toggle"
                        onClick={() => {
                          setActivePayment("credit card");
                        }}
                        style={{
                          borderColor:
                            activePayment && activePayment === "credit card"
                              ? "#009688" // Change to the desired background color
                              : "",
                        }}
                      >
                        <div className="base-menu">
                          <div className="base-icons">
                            <i className="fas fa-credit-card"></i>
                          </div>
                          <span>{t("Carte bancaire")}</span>
                        </div>
                      </a>
                    </li>
                  ) : null}
                  <li className="menu">
                    <a
                      className="menu-toggle"
                      data-active={total < 0 ? "true" : "true"}
                      onClick={() => {
                        setActivePayment("bon");
                      }}
                      style={{
                        borderColor:
                          activePayment && activePayment === "bon"
                            ? "#009688" // Change to the desired background color
                            : "",
                      }}
                    >
                      <div className="base-menu">
                        <div className="base-icons">
                          <i className="fas fa-credit-card"></i>
                        </div>
                        <span>Contre bon</span>
                      </div>
                    </a>
                  </li>
                  {/**currentClient && currentClient.equivalentMoney > 0 && */}
                  {/* Show fidelity option only if client has points */}
                  {cart.defaultClient._id !== cart.client_id &&
                    currentClient &&
                    Number(currentClient.equivalentMoney) > 0 && (
                      <li className="menu">
                        <a
                          data-active="false"
                          className="menu-toggle"
                          onClick={() => {
                            handleFideliteAmount(); // This now just loads available points
                            setActivePayment("points");
                          }}
                          style={{
                            borderColor:
                              activePayment === "points" ? "#009688" : "",
                          }}
                        >
                          <div className="base-menu">
                            <div className="base-icons">
                              <i className="fas fa-wallet"></i>
                            </div>
                            <span>
                              Points (
                              {currentClient?.equivalentMoney?.toFixed(2) || 0}{" "}
                              TND)
                            </span>
                          </div>
                        </a>
                      </li>
                    )}
                </>
              ) : (
                <li className="menu">
                  <a
                    className="menu-toggle"
                    data-active={total < 0 ? "true" : "true"}
                    style={{
                      borderColor:
                        activePayment && activePayment === "bon"
                          ? "#009688" // Change to the desired background color
                          : "",
                    }}
                  >
                    <div className="base-menu">
                      <div className="base-icons">
                        <i className="fas fa-credit-card"></i>
                      </div>
                      <span>Contre bon</span>
                    </div>
                  </a>
                </li>
              )}
            </ul>
          </nav>

          {activePayment === "cash" && total >= 0 && (
            <CashPaymentMethod
              total={total}
              onAmountChange={handleEnteredAmount}
              givenAmout={enteredAmount}
              enteredAmountCash={enteredAmountCash}
              remainingAmount={remainingAmount}
            />
          )}
          {activePayment === "virement" && total >= 0 && (
            <VirementPaymentMethod
              numVirement={numVirement}
              setNumeVirement={setNumeVirement}
              montantVirement={montantVirement}
              setMontantVirement={setMontantVirement}
              taxes={taxes}
              setTaxes={setTaxes}
              total={total}
              fraisVirement={selectedSocieteLivraison?.data?.virement}
              note={noteVirement}
              setFile={setFile}
              file={file}
              setNote={setNoteVirement}
              onAmountChange={handleEnteredAmount}
            />
          )}
          {activePayment === "cheque" && total >= 0 ? (
            <>
              {cheques.map((cheque: ChequeType, index: number) => (
                <ChequePaymentMethod
                  index={index + 1}
                  total={total}
                  enteredAmountCheque={cheque.amount}
                  maxAmount={remainingAmount + Number(cheque.amount || 0)}
                  tel={cheque.tel}
                  setTel={(tel: any) => updateCheque(index, { ...cheque, tel })}
                  num={cheque.num_cheque}
                  setNumCheque={(num_cheque: any) =>
                    updateCheque(index, { ...cheque, num_cheque })
                  }
                  echeance={cheque.echeance}
                  setEcheance={(echeance: any) =>
                    updateCheque(index, { ...cheque, echeance })
                  }
                  onAmountChange={(amount: any) =>
                    updateCheque(index, { ...cheque, amount })
                  }
                />
              ))}
              <button
                className="btn btn-primary"
                onClick={addCheque}
                style={{ width: "100%" }}
              >
                +
              </button>
            </>
          ) : null}

          {activePayment === "traite" && total >= 0 ? (
            <>
              {traites.map((t: TraiteType, index: number) => (
                <TraitePaymentMethod
                  index={index + 1}
                  total={total}
                  enteredAmountTraite={t.amount}
                  maxAmount={remainingAmount + Number(t.amount || 0)}
                  tel={t.tel}
                  setTel={(tel: any) => updateTraite(index, { ...t, tel })}
                  num={t.num_traite}
                  setNumTraite={(num_traite: any) =>
                    updateTraite(index, { ...t, num_traite })
                  }
                  echeance={t.echeance}
                  setEcheance={(echeance: any) =>
                    updateTraite(index, { ...t, echeance })
                  }
                  onAmountChange={(amount: any) =>
                    updateTraite(index, { ...t, amount })
                  }
                />
              ))}
              <button
                className="btn btn-primary"
                onClick={addTraite}
                style={{ width: "100%" }}
              >
                +
              </button>
            </>
          ) : null}
          {activePayment === "gift card" && total >= 0 && (
            <>
              <GiftCardPaymentMethod
                total={total}
                onAmountChange={handleEnteredAmountGiftCard}
                givenAmout={enteredAmount}
                enteredAmountGiftCard={enteredAmountGiftCard}
                ListGiftcard={ListGiftcard}
                setListGiftcard={setListGiftcard}
              />
            </>
          )}
          {activePayment === "credit card" && total >= 0 && (
            <CreditCardPaymentMethod
              total={total}
              onAmountChange={handleEnteredAmountCreditCard}
              givenAmout={enteredAmount}
              enteredAmountCreditCard={enteredAmountCreditCard}
              maxAmount={remainingAmount + Number(enteredAmountCreditCard || 0)}
            />
          )}
          {activePayment === "carte sedexo" && total >= 0 && (
            <CarteSedexoPaymentMethod
              total={total}
              onAmountChange={handleEnteredAmountCarteSedexo}
              givenAmout={enteredAmount}
              enteredAmountCartesedexo={enteredAmountCarteSedexo}
            />
          )}

          {activePayment === "points" && total >= 0 && (
            <PointsFidleliteMethod
              total={total}
              onAmountChange={handleEnteredAmountFidelite}
              givenAmout={enteredAmount}
              pointsFideliteEquivalent={fideliteAmount}
              setpointsFideliteEquivalent={setFideliteAmount}
              currentClient={currentClient}
            />
          )}

          {activePayment === "bon" && total >= 0 && (
            <BonReductionMethod cart={cart} />
          )}
        </div>

        {cart.order_id && cart.avance ? (
          <div
            className="cart-footer dark"
            style={{ position: "absolute", width: "95%" }}
          >
            <div
              className="widget-calendar-lists-scroll"
              style={{ width: "100%" }}
            >
              <button
                className={"btn btn-success mb-2" + btnClass}
                style={{ width: "100%", background: "#009688", height: "50px" }}
                disabled={isLoading}
                onClick={(e) => {
                  PayerReservation(cart);
                }}
              >
                {t("Payer")}
              </button>
            </div>
            <button
              className={"btn btn-success mb-2" + btnClass}
              style={{ width: "100%", background: "#009688", height: "50px" }}
              disabled={isLoading || total === 0}
              hidden={
                user && user.role_id?.libelle === "onlineSale" ? true : false
              }
              onClick={(e) => {
                resetAllPaymentAmounts();
                setactionreservation("ajout_avance");
                setshowReservationpopup(true);
              }}
            >
              {t("Ajouter Avance / duree")}
            </button>
          </div>
        ) : (
          <div className="cart-footer dark">
            <div
              className="widget-calendar-lists-scroll"
              style={{ width: "100%" }}
            >
              <button
                className={"btn btn-success mb-2" + btnClass}
                style={{ width: "100%", background: "#009688", height: "50px" }}
                disabled={
                  isLoading ||
                  (cart.items?.length === 0 &&
                    cart.refundedItems?.length === 0 &&
                    (!openedOrder || openedOrder?.items?.length === 0) &&
                    !cart?.selectedOrders?.length) ||
                  (cart.operationType === "Echange" &&
                    cart.items.every((item) => item.quantity < 0))
                }
                onClick={(e) => {
                  orderConfirmationAlert();
                }}
              >
                {t("confirm")}
              </button>

              <button
                className={"btn btn-success mb-2" + btnClass}
                style={{ width: "100%", background: "#009688", height: "50px" }}
                disabled={total === 0}
                hidden={
                  user && user.role_id?.libelle === "onlineSale" ? true : false
                }
                onClick={(e) => {
                  handlereserverOrder();
                }}
              >
                {t("reserver")}
              </button>
            </div>
          </div>
        )}
      </div>
      <Reservationpopup
        showModal={showReservationpopup}
        setshowModal={setshowReservationpopup}
        t={t}
        listClient={listClient}
        cart={cart}
        givenAmout={enteredAmount}
        remainingAmount={remainingAmount}
        confirmreservation={confirmreservation}
        dureeAvance={dureeAvance}
        action={actionreservation}
        AjouterAvance={AjouterAvance}
        activePayment={activePayment}
        total={total}
        enteredAmountCash={enteredAmountCash}
        handleEnteredAmount={handleEnteredAmount}
        cheques={cheques}
        updateCheque={updateCheque}
        addCheque={addCheque}
        traites={traites}
        updateTraite={updateTraite}
        addTraite={addTraite}
        enteredAmountCreditCard={enteredAmountCreditCard}
        handleEnteredAmountCreditCard={handleEnteredAmountCreditCard}
        enteredAmountCarteSedexo={enteredAmountCarteSedexo}
        handleEnteredAmountCarteSedexo={handleEnteredAmountCarteSedexo}
        ListGiftcard={ListGiftcard}
        setListGiftcard={setListGiftcard}
        enteredAmountGiftCard={enteredAmountGiftCard}
        handleEnteredAmountGiftCard={handleEnteredAmountGiftCard}
        fideliteAmount={fideliteAmount}
        handleEnteredAmountFidelite={handleEnteredAmountFidelite}
        currentClient={currentClient}
      />
      <VerifAdmin
        ShowModal={showModalAdmin}
        setShowModal={setshowModalAdmin}
        societe={societe_id}
        user={Admin}
        setuser={setAdmin}
        setConfirmer={setAdminVerif}
      />

      {ticketId ? (
        <>
          <OrderDetailsModal
            show={showModalTicket}
            setShow={setShowModalTicket}
            ticket_id={ticketId}
            order_id={openedOrderId}
          />
          {Reservation && (
            <TicketAvance
              ShowModal={showModalTicketAvance}
              setShowModal={setShowModalTicketAvance}
              ticket={ticketId}
              reservation={Reservation}
            />
          )}
        </>
      ) : null}
      <BonDeReductionTicket
        ShowModal={showModalTicketBon}
        setShowModal={setShowModalTicketBon}
        Bon_id={idbon}
      />
      {ShowModalActionCaisse && <HomeCaisse onCloseCaisse={onCloseCaisse} />}
    </div>
  );
};

export default PaymentDrawer;
